import axios from "axios";
import { useSelector } from "react-redux";

// Set defaults for axios
axios.defaults.withCredentials = true;

const access_token = localStorage.getItem('auth-token');

// Create axios instance with environment-based API URL
export default axios.create({
  // baseURL: 'http://localhost:8000',
  baseURL: 'https://api.blockfirstcapital.com',
  headers: {
    "Content-type": "application/json",
    withCredentials: true,
    Authorization: `Bearer ${access_token}`
  }
});